import { Link } from "@inertiajs/react"
import { Logo } from "./Logo"
import { SocialIcon } from "react-social-icons"

const productLinks = [
  { label: "Features", href: "/features" },
  { label: "How it works", href: "/how-it-works" },
  { label: "Pricing", href: "/pricing" },
  { label: "Email verification API", href: "/developers" },
  { label: "Use cases", href: "/use-cases" },
]

const compareLinks = [
  { label: "vs. NeverBounce", href: "/compare/neverbounce" },
  { label: "vs. ZeroBounce", href: "/compare/zerobounce" },
  { label: "vs. Findymail", href: "/compare/findymail" },
]

const companyLinks = [
  { label: "About", href: "/about" },
  { label: "Blog", href: "/blog" },
  { label: "Help center", href: "/help" },
  { label: "Contact", href: "/contact" },
]

const legalLinks = [
  { label: "Privacy", href: "/privacy" },
  { label: "Terms", href: "/terms" },
  { label: "GDPR", href: "/gdpr" },
  { label: "Security", href: "/security" },
]

const socialLinks: { label: string; href: string; network: string }[] = [
  { label: "X", href: "https://x.com/CleanMyListIO", network: "x" },
]

export function Footer() {
  return (
    <footer className="border-t border-ink-950/5 bg-white">
      <div className="mx-auto w-full max-w-7xl px-6 py-16 lg:px-8 lg:py-20">
        <div className="grid grid-cols-2 gap-x-8 gap-y-12 lg:grid-cols-[2fr_1fr_1fr_1fr_1fr]">
          <div className="col-span-2 lg:col-span-1">
            <Logo />
            <p className="mt-5 max-w-[40ch] text-pretty text-sm/6 text-ink-600">
              Clean your email list before you send. Fewer bounces, more inbox, happier mornings.
            </p>
            <div className="mt-6 flex items-center gap-x-2">
              {socialLinks.map((s) => (
                <SocialIcon
                  key={s.label}
                  url={s.href}
                  network={s.network}
                  aria-label={s.label}
                  target="_blank"
                  rel="noopener noreferrer"
                  fgColor="white"
                  bgColor="#1a1a1a"
                  style={{ width: 32, height: 32 }}
                />
              ))}
            </div>
          </div>

          <FooterColumn title="Product" links={productLinks} />
          <FooterColumn title="Compare" links={compareLinks} />
          <FooterColumn title="Company" links={companyLinks} />
          <FooterColumn title="Legal" links={legalLinks} />
        </div>

        <div className="mt-16 flex flex-col items-start justify-between gap-y-4 border-t border-ink-950/5 pt-8 sm:flex-row sm:items-center">
          <p className="text-sm text-ink-500">© {new Date().getFullYear()} CleanMyList. All rights reserved.</p>
          <p className="inline-flex items-center gap-x-2 text-sm text-ink-500">
            <span className="size-2 rounded-full bg-brand-500" aria-hidden="true" />
            All systems operational
          </p>
        </div>
      </div>
    </footer>
  )
}

function FooterColumn({ title, links }: { title: string; links: { label: string; href: string }[] }) {
  return (
    <div>
      <p className="text-sm font-semibold tracking-tight text-ink-950">{title}</p>
      <ul role="list" className="mt-4 flex flex-col gap-y-2.5">
        {links.map((l) => (
          <li key={l.href}>
            <Link href={l.href} className="text-sm font-normal text-ink-600 hover:text-ink-950">
              {l.label}
            </Link>
          </li>
        ))}
      </ul>
    </div>
  )
}
